export const getStorageKey = (tableName: string) => `tableSettings_${tableName}`;

export const loadColumnSettings = (name: string, defaultSettings: Record<string, boolean>) => {
  try {
    const savedSettings = localStorage.getItem(getStorageKey(name));
    return savedSettings ? JSON.parse(savedSettings) : defaultSettings;
  } catch {
    return defaultSettings;
  }
};

export const exportToCSV = (text: string) => {
  const hiddenElement = document.createElement('a');
  const date = new Date();
  hiddenElement.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
  hiddenElement.download = `${date.toISOString()}.csv`;
  hiddenElement.click();
};
